module.exports = __webpack_public_path__ + "static/media/help.6f589a20.svg";